import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases',
	path: '/projects/:projectKey/versions/:id?',
};
